import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import { selectData as selectAuthAccountBalance } from 'mt-react-common/common/reducers/data/reducer';

const authAccountBalanceRN = 'userFlowFundsModule.states.authAccountBalance';

// eslint-disable-next-line react/prefer-stateless-function
class HeaderBalance extends Component {
  render() {
    return (
      <li className="navbar-item-btn dropdown">
        <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <button className="btn btn-primary navbar-btn" type="button">
            {this.props.authAccountBalance.totalBalance}{' '}
            <i className="fa fa-rub" />
          </button>
        </span>
        <div
          className="dropdown-menu dropdown-menu-balance"
          aria-labelledby="dLabel"
        >
          <div className="dropdown-menu-header text-center">
            <h4>{t('Баланс')}</h4>
          </div>
          <div className="dropdown-menu-body">
            <div className="row">
              <div className="col-xs-12 col-sm-12">
                <h5>{this.props.authAccountBalance.balanceAdsAccount.name}</h5>
                <p>{this.props.authAccountBalance.balanceAdsAccount.sum} ₽</p>
                <NavLink
                  to="/main/my-balance/pay/payment"
                  className="btn btn-sm btn-block btn-primary"
                >
                  {t('Пополнить')}
                </NavLink>
              </div>
              <div className="col-xs-12 col-sm-12">
                <h5>{this.props.authAccountBalance.balanceMainAccount.name}</h5>
                <p>{this.props.authAccountBalance.balanceMainAccount.sum} ₽</p>
                <NavLink
                  to="/main/my-balance/payout"
                  className="btn btn-sm btn-block btn-primary"
                >
                  {t('Вывести средства')}
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

HeaderBalance.propTypes = {
  authAccountBalance: PropTypes.shape({
    balanceMainAccount: PropTypes.shape({
      name: PropTypes.string,
      sum: PropTypes.string
    }).isRequired,
    balanceAdsAccount: PropTypes.shape({
      name: PropTypes.string,
      sum: PropTypes.string
    }).isRequired,
    totalBalance: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  authAccountBalance: selectAuthAccountBalance(state, authAccountBalanceRN)
});

export default connect(mapStateToProps)(HeaderBalance);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/HeaderBalance.js